/**
 * Maps Gate-internal action/error status values to standard DomainAvailabilityStatus
 * values used consistently across all platforms (Focus Widget, Account Level,
 * Mobile, Concierge, Success Page, Storefront).
 */
const DOMAIN_AVAILABILITY_STATUS_MAP = {
  // Actions -> DomainAvailabilityStatus
  purchase: 'AVAILABLE_FOR_PURCHASE',
  connect: 'OWNED_OUTSIDE_OF_WIX',
  assign: 'CAN_ASSIGN_TO_SITE',
  transfer: 'CAN_TRANSFER_TO_ACCOUNT',
  // Errors -> DomainAvailabilityStatus
  notSupportedTld: 'NOT_SUPPORTED_TLD',
  notSupportedTldRegional: 'NOT_SUPPORTED_TLD',
  domainTakenInWix: 'DOMAIN_IN_ANOTHER_WIX_ACCOUNT',
  alreadyAssigned: 'CAN_ASSIGN_TO_SITE',
  alreadyAssignedToThisSite: 'ALREADY_ASSIGNED_TO_THIS_SITE',
  INVALID_DOMAIN_NAME: 'INVALID_DOMAIN',
  // Validation errors -> INVALID_DOMAIN
  LABEL_INVALID_CHARS: 'INVALID_DOMAIN',
  TWO_CONSECUTIVE_DOTS: 'INVALID_DOMAIN',
  DOMAIN_TOO_SHORT: 'INVALID_DOMAIN',
  // Floating / already-owned domain in this account
  floatingDomain: 'CAN_ASSIGN_TO_SITE',
  // Subdomain statuses
  subdomainTakenInWix: 'DOMAIN_IN_ANOTHER_WIX_ACCOUNT',
  rootDomainIsConnectedByPointing: 'OWNED_OUTSIDE_OF_WIX',
  subdomainRootIsNotConnected: 'NOT_SUPPORTED_TLD',
  subdomainRootIsConnectedByDns: 'OWNED_OUTSIDE_OF_WIX',
  subdomainRootIsRegistered: 'OWNED_OUTSIDE_OF_WIX',
  languageCodeSubdomain: 'NOT_SUPPORTED_TLD',
  // Upgrade-related -> closest DomainAvailabilityStatus
  upgrade: 'AVAILABLE_FOR_PURCHASE',
  upgradeRequirePurchase: 'AVAILABLE_FOR_PURCHASE',
  upgradeRequirePurchaseSubdomain: 'AVAILABLE_FOR_PURCHASE',
  upgradeRequireConnect: 'OWNED_OUTSIDE_OF_WIX',
  upgradeRequireAssign: 'CAN_ASSIGN_TO_SITE',
  upgradeRequireTransferIn: 'CAN_TRANSFER_TO_ACCOUNT'
};
export const mapResultToDomainAvailabilityStatus = result => {
  if (!result) {
    return result;
  }
  return DOMAIN_AVAILABILITY_STATUS_MAP[result] ?? result;
};
//# sourceMappingURL=domainAvailabilityStatusMap.js.map